import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@nesso/ui/primitives/alert-dialog';

import { SUPPORT_EMAIL } from '@/shared/constants/support';

type Props = {
    open: boolean;
    onClose: () => void;
};

export function ProfileCheckInboxDialog({ open, onClose }: Props) {
    return (
        <AlertDialog open={open} onOpenChange={(next) => !next && onClose()}>
            <AlertDialogContent className="sm:max-w-lg">
                <AlertDialogHeader className="text-left">
                    <AlertDialogTitle>Check your inbox</AlertDialogTitle>
                    <AlertDialogDescription>
                        <span>
                            Click the link in the email to verify your contact information. Keep in
                            mind, the link will only be active for the next 72 hours.
                        </span>
                        <br />
                        <br />
                        <span>
                            Can&rsquo;t find it? Give your spam folder a quick look. If it&rsquo;s
                            still missing, contact {SUPPORT_EMAIL}
                        </span>
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogAction onClick={onClose}>OK</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
